import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear session storage
    const isAdminAuthenticated = sessionStorage.getItem("isAdminAuthenticated");
    if (isAdminAuthenticated) {
      sessionStorage.removeItem("isAdminAuthenticated");
      // Redirect to login page
      navigate("/login");
    } else {
      sessionStorage.removeItem("isUser");
      navigate("/login");
    }
  };

  const isAdminAuthenticated = sessionStorage.getItem("isAdminAuthenticated");
  const isUserAuthenticated = sessionStorage.getItem("isUser");

  return (
    <nav className="bg-white p-3">
      <div className="my-2 mx-4 flex">
        <Link to="/" className="text-white text-xl font-bold">
          <img
            src={
              process.env.PUBLIC_URL +
              "/imgs/swe_logo/SWE_Logo_Rutgers_University_4C.png"
            }
            alt="SWE Logo"
            className="w-20"
          />
        </Link>
        <div className="flex justify-end w-full space-x-32">
          {isAdminAuthenticated || isUserAuthenticated ? (
            <>
              <Link
                to="/"
                className="text-swe-purple font-bold hover:text-swe-red text-3xl mx-4"
                onClick={handleLogout}
              >
                Logout
              </Link>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="text-swe-purple hover:text-swe-red text-3xl mx-4"
              >
                Login
              </Link>
              {/* Add Signup Link */}
              <Link
                to="/signup"
                className="text-swe-purple hover:text-swe-red text-3xl"
              >
                Signup
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
